// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SecurityAssessment_sectionTitle__0Va2R","introText":"SecurityAssessment_introText__xDBED"};